"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessControlListRepository = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_2 = require("typeorm");
const user_role_entity_1 = require("../../../../service-lib/src/lib/entities/user-role.entity");
const role_acl_category_action_map_entity_1 = require("../../../../service-lib/src/lib/entities/role-acl-category-action-map.entity");
const acl_category_action_map_entity_1 = require("../../../../service-lib/src/lib/entities/acl-category-action-map.entity");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
let AccessControlListRepository = class AccessControlListRepository {
    constructor(userRoleRepository, roleAclMapRepository, aclCategoryActionMapRepository) {
        this.userRoleRepository = userRoleRepository;
        this.roleAclMapRepository = roleAclMapRepository;
        this.aclCategoryActionMapRepository = aclCategoryActionMapRepository;
    }
    /**
     * Retrieves the permissions for a specific user based on their roles and access control mappings.
     */
    async getUserPermissions(userId, categoryKey) {
        try {
            const userRoles = await this.userRoleRepository
                .createQueryBuilder("userRole")
                .leftJoinAndSelect("userRole.role", "role")
                .leftJoin("userRole.user", "user")
                .where("user.id = :userId", { userId })
                .getMany();
            if (!userRoles.length) {
                return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, "No roles found for the user");
            }
            const permissions = {
                roleId: userRoles[0].role.id,
                roleName: userRoles[0].role.name,
                access: {},
            };
            for (const userRole of userRoles) {
                try {
                    let query = this.roleAclMapRepository
                        .createQueryBuilder("roleAcl")
                        .leftJoinAndSelect("roleAcl.aclCategoryActionMap", "map")
                        .leftJoinAndSelect("map.aclCategory", "category")
                        .leftJoinAndSelect("map.aclAction", "action")
                        .leftJoin("roleAcl.role", "role")
                        .where("role.id = :roleId", { roleId: userRole.role.id });
                    if (categoryKey) {
                        query = query.andWhere("category.categoryKey = :categoryKey", { categoryKey });
                    }
                    const rolePermissions = await query.getMany();
                    for (const rolePermission of rolePermissions) {
                        try {
                            const category = rolePermission.aclCategoryActionMap.aclCategory;
                            const action = rolePermission.aclCategoryActionMap.aclAction;
                            // Build the nested structure
                            if (!permissions.access[category.applicationScope]) {
                                permissions.access[category.applicationScope] = {};
                            }
                            if (!permissions.access[category.applicationScope][category.categoryKey]) {
                                permissions.access[category.applicationScope][category.categoryKey] = {};
                            }
                            if (!permissions.access[category.applicationScope][category.categoryKey]['parent']) {
                                permissions.access[category.applicationScope][category.categoryKey]['parent'] = category.parent;
                            }
                            permissions.access[category.applicationScope][category.categoryKey][action.actionKey] = true;
                        }
                        catch (error) {
                            console.error("Error processing role permission:", rolePermission, error);
                            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error
                                ? error.message
                                : "Error processing role permission");
                        }
                    }
                }
                catch (error) {
                    console.error("Error fetching role permissions for role:", userRole.role.id, error);
                    return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error
                        ? error.message
                        : "Error fetching role permissions");
                }
            }
            return permissions;
        }
        catch (error) {
            console.error("Error fetching user permissions:", error);
            return (0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error ? error.message : "Internal server error");
        }
    }
    async getAclMetadata() {
        const maps = await this.aclCategoryActionMapRepository.find({
            relations: { aclCategory: true, aclAction: true },
        });
        const grouped = new Map();
        for (const map of maps) {
            const category = map.aclCategory;
            if (!grouped.has(category.id)) {
                grouped.set(category.id, { category, actions: [] });
            }
            grouped.get(category.id).actions.push({
                id: map.id,
                name: map.aclAction.name,
                actionKey: map.aclAction.actionKey,
            });
        }
        return Array.from(grouped.values());
    }
    async getRoleAcl(roleId) {
        const records = await this.roleAclMapRepository.find({
            where: { role: { id: roleId } },
            relations: {
                aclCategoryActionMap: {
                    aclCategory: true,
                    aclAction: true
                },
            },
        });
        const categoryActionMap = [];
        records.forEach(element => {
            const map = categoryActionMap.find(map => map.aclCategoryId === element.aclCategoryActionMap.aclCategory.id);
            if (map) {
                map.aclCatActionMapIds.push(element.aclCategoryActionMap.id);
            }
            else {
                categoryActionMap.push({
                    aclCategoryId: element.aclCategoryActionMap.aclCategory.id,
                    aclCatActionMapIds: [element.aclCategoryActionMap.id]
                });
            }
        });
        return categoryActionMap;
    }
    async updateRoleAcl(roleId, aclIds) {
        await this.roleAclMapRepository.delete({ role: { id: roleId } });
        if (aclIds?.length) {
            const entities = aclIds.map((id) => this.roleAclMapRepository.create({
                role: { id: roleId },
                aclCategoryActionMap: { id },
                createdBy: "system",
                updatedBy: "system",
            }));
            await this.roleAclMapRepository.save(entities);
        }
        return true;
    }
};
exports.AccessControlListRepository = AccessControlListRepository;
exports.AccessControlListRepository = AccessControlListRepository = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(user_role_entity_1.UserRole)),
    tslib_1.__param(1, (0, typeorm_1.InjectRepository)(role_acl_category_action_map_entity_1.RoleAclCategoryActionMap)),
    tslib_1.__param(2, (0, typeorm_1.InjectRepository)(acl_category_action_map_entity_1.AclCategoryActionMap)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object, typeof (_b = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _b : Object, typeof (_c = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _c : Object])
], AccessControlListRepository);
